<template>
  <div class="sum-description-component">
    <div class="columns">
        <div
          class="column is-truncate-text is-8"
          :class="{
            'pb-0': type === 'recurrent'
          }"
        >
          <span class="is-size-5 has-text-weight-bold has-text-grey-dark is-no-wrap">
            {{ name }}
          </span>
        </div>
        <div
            class="column is-4"
            :class="{
              'pb-0': type === 'recurrent'
            }"
        >
          <span class="is-pulled-right">
            <span
                class="is-size-6 has-text-weight-light"
                :class="{
                  'has-text-black': type === 'total',
                  'has-text-grey-secondary': !(type === 'total')
                }"
            >R$ </span>
            <span
                class="has-text-weight-light"
                :class="{
                  'has-text-black is-size-4': type === 'total',
                  'has-text-grey-secondary is-size-6': !(type === 'total')
                }"
            >
              <span v-if="type !== 'recurrent'">{{ price }}</span>
              <span v-else>{{ formatPrice(price * seasonality) }}</span>
            </span>
            <span v-if="type === 'recurrent'" class="is-size-6 has-text-weight-light has-text-grey-secondary">
              {{ unitOfMeasurement }}
            </span>
          </span>
        </div>
    </div>
  </div>
</template>

<script>

export default {

  name: 'sum-description',

  props: {
    name: {
      required: true,
      type: String
    },
    price: {
      required: true,
      type: [ String, Number ]
    },
    type: {
      required: true,
      type: String
    },
    seasonality: {
      required: true,
      type: Number
    }
  },

  data() {
    return {
      unit_of_measurements: {
        1: '/mês',
        6: '/semes..',
        12: '/ano',
      }
    }
  },

  methods: {
    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },
  },

  computed: {
    unitOfMeasurement() {
      return this.unit_of_measurements[this.seasonality]
    }
  }

}

</script>